import { isAuthenticated } from "../../utils/identityUtils";
import { getSegmentIds } from "../../utils/getSegmentIds";
import config from "../../config";
import {
  getCountryFromLocalStorage,
  saveCountryToLocalStorage,
  isPremierAvailable,
  sortAlphabetically,
  sortBySelectedCountry,
  addXSiteOrigin,
} from "../../helpers";
import { fetchCountry, receiveCountry } from "../CountrySelector";
import { toggleSelector } from "../Modal";
import { setOfferedFreeTrial } from "../PremierPageFrame";
import { fetchDelivery } from "../PremierPricingTable";

export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_COUNTRIES_ERROR = "FETCH_COUNTRIES";
export const RECEIVE_COUNTRIES = "RECEIVE_COUNTRIES";
export const SELECT_COUNTRY = "SELECT_COUNTRY";
export const SET_INITIAL_COUNTRY = "SET_INITIAL_COUNTRY";
export const SORT_COUNTRIES = "SORT_COUNTRIES";
export const RECEIVE_COUNTRY = "RECEIVE_COUNTRY";

function fetchCountriesData() {
  return {
    type: FETCH_COUNTRIES,
  };
}

function receiveCountries(data) {
  return {
    type: RECEIVE_COUNTRIES,
    countriesData: data,
  };
}

function fetchError(err) {
  return {
    type: FETCH_COUNTRIES_ERROR,
    payload: err,
  };
}

function setSelectedCountry(countryCode) {
  return {
    type: SELECT_COUNTRY,
    selectedCountry: countryCode,
  };
}

function setInitialCountry(countryCode) {
  return {
    type: SET_INITIAL_COUNTRY,
    selectedCountry: countryCode,
  };
}

function sortCountries(countries) {
  return {
    type: SORT_COUNTRIES,
    countriesData: countries,
  };
}

export const getSegmentsHeader = async (additionalHeaders) => {
  const response = await getSegmentIds();
  if (response.length > 0) {
    const segmentIds = response.map((segment) => segment.segmentId).join(",");
    additionalHeaders["asos-c-segmentids"] = segmentIds;
  }
  return additionalHeaders;
};

export function fetchCountries(country, currency, storeId, language) {
  return async (dispatch) => {
    dispatch(fetchCountriesData());
    dispatch(fetchDelivery(country, currency, storeId));
    let additionalHeaders = {};
    const isLoggedIn = await isAuthenticated();
    if (isLoggedIn) {
      additionalHeaders = await getSegmentsHeader(additionalHeaders);
    }
    return fetch(
      addXSiteOrigin(
        `${config.subscriptionsEndpoint}?store=${storeId}&currency=${currency}&lang=${language}&showTrialOffers=${isLoggedIn}`
      ),
      {
        headers: additionalHeaders,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return dispatch(fetchError(response.message));
      })
      .then((data) => {
        if (Array.isArray(data)) {
          config.storeId = "COM";
          config.language = "en-GB";
        }

        const countriesData = sortAlphabetically(data.subscriptionOptions);
        const country = getCountryFromLocalStorage();
        const premierAvailable = isPremierAvailable(country, countriesData);
        const countryCode = premierAvailable ? country : "GB";
        const countries = sortBySelectedCountry(countryCode, countriesData);
        dispatch(receiveCountries(countries));
        dispatch(setInitialCountry(countryCode));
        dispatch(receiveCountry(data, !!premierAvailable));

        const initialCountry = countriesData.find(
          (item) => item.country.code === countryCode
        );
        dispatch(setOfferedFreeTrial(!!initialCountry?.trialOffer));
      })
      .catch((err) => {
        dispatch(fetchError(err.message));
      });
  };
}

export function setCountry(
  countryCode,
  countries,
  language,
  currency,
  storeId
) {
  return (dispatch, getState) => {
    const { returnFocus } = getState().Modal; // eslint-disable-line no-unused-vars
    const sortedCountries = sortAlphabetically(countries);
    const sortedCountriesBySelectedCountry = sortBySelectedCountry(
      countryCode,
      sortedCountries
    );
    saveCountryToLocalStorage(countryCode);
    dispatch(sortCountries(sortedCountriesBySelectedCountry));
    dispatch(setSelectedCountry(countryCode));
    dispatch(toggleSelector(false, returnFocus));
    dispatch(fetchCountry(countryCode, language, currency, storeId, countries));
  };
}
